export default "__VITE_ASSET__BQOtTc5w__"